import { useEffect, useRef, useState } from 'react';

interface TabLike {
  label: string;
  visible?: boolean;
}

const menuButtonWidth = 40; // Width of the menu button in pixels

const useVisibleTabs = <T extends TabLike>(tabs: T[]) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [visibleCount, setVisibleCount] = useState(tabs.length);

  useEffect(() => {
    const measureWidths = () => {
      if (!containerRef.current) return;

      const containerWidth = containerRef.current.offsetWidth - menuButtonWidth;
      let total = 0;
      let count = 0;

      const tempContainer = document.createElement('div');
      tempContainer.style.cssText = `
        position: absolute;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        white-space: nowrap;
      `;
      document.body.appendChild(tempContainer);

      for (const tab of tabs) {
        if (typeof tab.visible !== 'undefined' && !tab.visible) continue;

        const div = document.createElement('div');
        div.innerText = tab.label;
        div.style.cssText = `
          display: inline-block;
          font-size: 16px;
          font-weight: 400;
          letter-spacing: 0.034em;
          font-family: Roboto, Helvetica, Arial, sans-serif;
          padding: 12px;
          text-transform: capitalize;
        `;
        tempContainer.appendChild(div);

        const width = div.offsetWidth;

        if (total + width > containerWidth) break;

        total += width;
        count++;
      }

      document.body.removeChild(tempContainer);
      setVisibleCount(count);
    };

    measureWidths();
    window.addEventListener('resize', measureWidths);
    return () => window.removeEventListener('resize', measureWidths);
  }, [tabs]);

  const visibleTabs = tabs.filter((t) => t.visible ?? true).slice(0, visibleCount);
  const overflowTabs = tabs.filter((t) => t.visible ?? true).slice(visibleCount);

  return {
    containerRef,
    visibleTabs,
    overflowTabs,
  };
}

export default useVisibleTabs;
